<template>
  <div class="switch relative overflow-hidden inline-flex items-baseline text-center">
    <AtomSwitchInput :id="id" :value="value" :disabled="disabled" :type="type" :name="name" @select="onSelect" />
    <AtomSwitchLabel :id-for="id" :content="label" :icon="icon" :disabled="disabled" @select="onSelect" />
  </div>
</template>

<script>
import AtomSwitchInput from '../../atoms/forms/AtomSwitchInput'
import AtomSwitchLabel from '../../atoms/forms/AtomSwitchLabel'

export default {
  name: 'MoleculeSwitch',
  components: {
    AtomSwitchInput,
    AtomSwitchLabel,
  },
  props: ['label', 'id', 'disabled', 'icon', 'type', 'name', 'selected'],
  emits: ['select'],
  data() {
    return {
      value: !!this.selected,
    }
  },
  watch: {
    selected() {
      this.value = !!this.selected
    },
  },
  methods: {
    onSelect(value) {
      this.value = value
      this.$emit('select', { id: this.id, value })
    },
  },
}
</script>

<style lang="postcss" scoped>
.switch {
  label {
    @apply overflow-hidden border rounded-[51px] text-sm md:text-base py-[5px] px-[14px] text-gray-100 border-gray-500;
  }
  input:not(:disabled) {
    &:checked {
      & + label {
        @apply text-white;
        &:before {
          transform: translateZ(0);
        }
        ::v-deep svg {
          path {
            fill: #fff;
          }
        }
      }
    }
    & + label {
      ::v-deep svg {
        width: 12px;
        height: 12px;
      }
      &:before {
        @apply absolute bg-gray-100 left-0 w-full z-[-1] top-[-0.1rem] bottom-[-0.1rem] content-[''];
        height: calc(100% + 0.2rem);
        transform: translate3d(0, 100%, 0);
        transition: transform 0.3s var(--ease-out);
      }
    }
  }
}
input:checked + label,
input:not(:checked) + label {
  @apply relative cursor-pointer;
}
input:disabled + label {
  @apply text-white bg-gray-500 cursor-not-allowed;
  ::v-deep svg path {
    fill: #fff;
  }
  &:before {
    @apply border-gray-500;
  }
}
</style>
